<template>
  <!-- .company-info-basic .cib -->
  <div>
    <div class="cib" v-if="openBool">
      <Row>
        <Col span="12">
          <div class="cib-l">
            <div class="cib-form">
              <Form
                ref="formInline"
                :model="formInline"
                :rules="ruleInline"
                label-position="right"
                :label-width="150"
                @submit.native.prevent
              >
                <FormItem style="margin-bottom: 0" v-if="commitInfo && editStatus">
                  <div style="color: #f00">
                    您于{{
                      commitInfo.changeTime | moment("YYYY/MM/DD HH:mm:ss")
                    }}提交的修改,尚未审核
                    <!-- <span v-if="commitInfo.status === 1">审核通过</span>
                      <span v-if="commitInfo.status === -1">审核未通过</span>  -->
                    <span
                      style="color: #1890ff; margin-left: 10px; cursor: pointer"
                      @click="openBool = false"
                      >查看我的修改</span
                    >
                  </div>
                </FormItem>
                <FormItem label="公司名称：" prop="name">
                  <Input
                    type="text"
                    v-model="formInline.name"
                    disabled
                    placeholder="请输入公司全称"
                  />
                  <br />
                  <span style="font-size: 12px; color: #a7a7a7"
                    >(公司名称必须和营业执照一致)</span
                  >
                </FormItem>
                <FormItem label="公司简称：" prop="shortName">
                  <Input
                    type="text"
                    v-model="formInline.shortName"
                    :disabled="commitInfo && editStatus ? true : false"
                    placeholder="请输入公司简称"
                  />
                </FormItem>
                <FormItem label="公司英文名：">
                  <Input
                    type="text"
                    v-model="formInline.nameEn"
                    :disabled="commitInfo && editStatus ? true : false"
                    placeholder="请输入公司英文名"
                  />
                </FormItem>
                <FormItem label="公司英文简称：">
                  <Input
                    type="text"
                    v-model="formInline.ShortNameEn"
                    :disabled="commitInfo && editStatus ? true : false"
                    placeholder="请输入公司英文简称"
                  />
                </FormItem>
                <!-- 企业类型 -->
                <FormItem label="企业类型：" prop="type">
                  <Select
                    v-model="formInline.type"
                    placeholder="请选择企业类型"
                    :disabled="commitInfo && editStatus ? true : false"
                  >
                    <Option
                      v-for="(item, index) in exTypeList"
                      :key="item.name"
                      :value="item.name"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem label="人员规模：" prop="staff">
                  <Select
                    v-model="formInline.staff"
                    placeholder="请选择人员规模"
                    :disabled="commitInfo && editStatus ? true : false"
                  >
                    <Option
                      v-for="(item, index) in staffArr"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.value }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem label="年销售额：" prop="sales">
                  <Input
                    type="text"
                    v-model="formInline.sales"
                    placeholder="请输入年销售额"
                    :disabled="commitInfo && editStatus ? true : false"
                  />
                </FormItem>
                <FormItem label="公司网址：" prop="Website">
                  <Input
                    type="text"
                    v-model="formInline.Website"
                    :disabled="commitInfo && editStatus ? true : false"
                    placeholder="请输入公司网址"
                  />
                </FormItem>

                <FormItem label="国家/地区：" prop="country">
                  <Select
                    v-model="formInline.country"
                    placeholder="请选择国家/地区"
                    filterable
                    :disabled="commitInfo && editStatus ? true : false"
                  >
                    <Option
                      v-for="(item, index) in countryList"
                      :key="item.name"
                      :value="item.name"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem
                  label="所在省市："
                  style="margin-bottom: 0"
                  :required="true"
                  v-if="formInline.country === '中国'"
                >
                  <Row type="flex" justify="space-between">
                    <Col span="11">
                      <FormItem prop="province">
                        <Select
                          v-model="formInline.province"
                          placeholder="请选择省份"
                          @on-change="changeProvince"
                          :disabled="commitInfo && editStatus ? true : false"
                        >
                          <Option
                            v-for="(item, index) in provinceArr"
                            :key="index"
                            :value="item.shortname ? item.shortname : item.name"
                            @click.native="changeProvinceValue(item)"
                            >{{ item.shortname || item.name }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="11" v-if="citiesArr && citiesArr.length">
                      <FormItem prop="city">
                        <Select
                          v-model="formInline.city"
                          placeholder="请选择城市"
                          @on-change="changeCity"
                          :disabled="commitInfo && editStatus ? true : false"
                        >
                          <Option
                            v-for="(item, index) in citiesArr"
                            :key="index"
                            :value="item.shortname ? item.shortname : item.name"
                            >{{ item.shortname || item.name }}</Option
                          >
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>

                <FormItem label="地址：" prop="address">
                  <Input
                    type="text"
                    v-model="formInline.address"
                    placeholder="请输入详细地址"
                    :disabled="commitInfo && editStatus ? true : false"
                  />
                </FormItem>
                <FormItem label="统一社会信用代码：" prop="CreditCode">
                  <Input
                    type="text"
                    v-model="formInline.CreditCode"
                    placeholder="请输入统一社会信用代码"
                    :disabled="commitInfo && editStatus ? true : false"
                  />
                </FormItem>

                <FormItem label="企业资产类型：" prop="BusinessType">
                  <Select
                    v-model="formInline.BusinessType"
                    style="width: 100%"
                    :disabled="commitInfo && editStatus ? true : false"
                  >
                    <Option
                      v-for="item in BusinessList"
                      :value="item.name"
                      :key="item.name"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>

                <FormItem label="企业经营类型：" prop="Nature">
                  <Select
                    v-model="formInline.Nature"
                    style="width: 100%"
                    :disabled="commitInfo && editStatus ? true : false"
                  >
                    <Option
                      v-for="item in NatureList"
                      :value="item.name"
                      :key="item.name"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
                <FormItem label="公司详情：" :required="true">
                  <div class="no-padding">
                    <customComponentCommon
                      v-model="Introduction"
                      :type="commonType"
                      @change="changModal"
                      v-if="!editStatus"
                    ></customComponentCommon>
                    <customComponentCommonDisplay
                      v-model="Introduction"
                      :type="commonType"
                      @change="changModal"
                      v-else
                    ></customComponentCommonDisplay>
                  </div>
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    @click="handleSubmit('formInline')"
                    style="width: 154px"
                    v-if="!editStatus"
                    >保存</Button
                  >
                </FormItem>
              </Form>
            </div>
          </div>
        </Col>
        <Col span="12">
          <div class="cib-r" style="padding-top: 57px">
            <Form label-position="right" :label-width="120" @submit.native.prevent>
              <FormItem label="Logo：" prop="name">
                <div class="logo-example">
                  <template v-if="uploadList && uploadList.length">
                    <div
                      class="my-upload-list"
                      v-for="(item, index) in uploadList"
                      :key="'upload' + index"
                      style="
                        width: 150px;
                        height: 150px;
                        line-height: 150px;
                        border: 1px solid #bfbfbf;
                      "
                    >
                      <template v-if="item.status === 'finished'">
                        <img
                          :src="item.url"
                          style="width: 150px; height: 150px"
                          v-if="item.url"
                        />
                        <img :src="Logo" style="width: 150px; height: 150px" v-else />
                        <div class="my-upload-list-cover">
                          <Icon
                            type="ios-eye-outline"
                            @click.native="handleView(item.url)"
                          ></Icon>
                          <!-- <Icon
                        type="ios-trash-outline"
                        @click.native.stop.prevent="handleRemoveByArr(item)"
                          ></Icon>-->
                        </div>
                      </template>
                      <template v-else>
                        <Spin
                          v-if="item.showProgress"
                          style="width: 150px; height: 150px"
                        >
                          <Icon
                            type="ios-loading"
                            size="20"
                            class="demo-spin-icon-load"
                          ></Icon>
                        </Spin>
                      </template>
                    </div>
                  </template>

                  <div
                    class="my-upload-list"
                    style="
                      width: 150px;
                      height: 150px;
                      line-height: 150px;
                      border: 1px solid #bfbfbf;
                    "
                    v-else
                  >
                    <img :src="Logo" style="width: 150px; height: 150px" />
                  </div>
                  <div class="logo-example-box">
                    <div class="logo-example-item z-large-s">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>图片尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-m">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>图片尺寸：200*200px</p>
                    </div>
                    <div class="logo-example-item z-large-l">
                      <img :src="uploadList[0].url" v-if="uploadList[0]" />
                      <img :src="Logo" v-else-if="Logo" />
                      <img src="@assets/img/empty.png" v-else />
                      <p>图片尺寸：200*200px</p>
                    </div>
                  </div>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  :action="uploadUrl"
                  style="display: inline-block; position: relative"
                >
                  <Button icon="ios-cloud-upload-outline" v-if="!editStatus"
                    >更改Logo</Button
                  >
                  <!-- <div style="width: 80px;height:80px;padding-top: 7px;">
                    <div>
                      +
                      <p>上传图片</p>
                    </div>
                  </div>-->
                  <!-- 蒙版 -->
                  <div
                    style="
                      position: absolute;
                      opacity: 0;
                      width: 115px;
                      height: 34px;
                      left: 0;
                      top: 0;
                      cursor: pointer;
                    "
                    @click.stop="selectType"
                    v-if="!editStatus"
                  ></div>
                </Upload>
                <p class="upload-p" v-if="!editStatus">
                  (图片要求：2M以下的jpg或png，建议尺寸120*120px)
                </p>
              </FormItem>

              <FormItem label="营业执照：" :required="true">
                <div class="my-upload">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList2"
                    :key="'upload2-' + index"
                    style="width: 150px; height: 100px"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width: 150px; height: 100px" />
                      <div class="my-upload-list-cover">
                        <Icon
                          type="ios-eye-outline"
                          @click.native="handleView(item.url)"
                        ></Icon>
                        <Icon
                          type="ios-trash-outline"
                          v-if="!editStatus"
                          @click.native="handleRemove(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 150px; height: 100px">
                        <Icon
                          type="ios-loading"
                          size="20"
                          class="demo-spin-icon-load"
                        ></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload2"
                    :show-upload-list="false"
                    :default-file-list="defaultList2"
                    :on-success="handleSuccess2"
                    :format="['jpg', 'jpeg', 'png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize2"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    :before-upload="handleBeforeUpload2"
                    style="display: inline-block; width: 150px"
                    v-show="uploadList2 && uploadList2.length < 1"
                  >
                    <div style="width: 150px; height: 100px; padding-top: 17px">
                      <div style="font-size: 20px">
                        +
                        <p style="font-size: 14px">上传</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="
                        position: absolute;
                        opacity: 0;
                        width: 150px;
                        height: 100px;
                        left: 0;
                        top: 0;
                      "
                      @click.stop="selectType2"
                    ></div>
                  </Upload>
                </div>
                <div class="my-upload-tip">（图片要求：4M以下的jpg或png）</div>
              </FormItem>
            </Form>
          </div>
        </Col>
      </Row>

      <!-- 选择文件上传方式 -->
      <imgUpload
        @upload:local="uploadLocal"
        @upload:material="uploadMaterial"
        :maxCount="1"
        v-model="uploadChooseShowed"
      />
      <!-- 选择文件上传方式 -->
      <imgUpload
        @upload:local="uploadLocal2"
        @upload:material="uploadMaterial2"
        :maxCount="1"
        v-model="uploadChooseShowed2"
      />
      <!-- 图片查看 -->
      <iModal title="图片查看" cancel-text v-model="visible">
        <div style="text-align: center">
          <img :src="imgName" v-if="visible" style="max-width: 100%" />
        </div>
      </iModal>
    </div>
    <companyInfoBasicDisplay
      v-if="!openBool && !openBoolEdit"
      @changeOpen="openBool = true"
      @changeOpen2="openBoolEdit = true"
    ></companyInfoBasicDisplay>
    <companyInfoBasicEdit @finish="finish" v-if="openBoolEdit" />
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { provinces } from "@/other/provinces";
import { mapGetters, mapMutations, mapActions } from "vuex";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";
import customComponentCommonDisplay from "@components/custom-component/custom-component-common-display.vue";
import companyInfoBasicDisplay from "../company-info-basic-display/company-info-basic-display.vue";
import companyInfoBasicEdit from "../company-info-basic-edit/company-info-basic-edit.vue";
import imgUpload from "@components/imgUpload/imgUpload.vue";
import defaultLogo from "@assets/img/empty.png";

export default {
  name: "company-info-basic",
  data() {
    const that = this;
    const cityValid = (rule, value, callback) => {
      if (that.formInline.country === "中国") {
        if (value) {
          callback();
        } else {
          callback(new Error("此选项为必填项"));
        }
      } else {
        callback();
      }
    };

    return {
      openBool: true,
      openBoolEdit: false,
      commonType: 2,
      Introduction: [],
      provinceArr: [],
      citiesArr: [],

      countryList: [],
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false, // 控制文件上传方式的显示和隐藏
      formInline: {
        // form双向绑定
        name: "",
        shortName: "",
        ShortNameEn: "",
        address: "",
        nameEn: "",
        introduction: "",
        country: "中国",
        province: "",
        city: "",
        Website: "",
        CreditCode: "",
        BusinessType: "",
        Nature: "",
        type: "", // 企业类型
        staff: "", // 人员规模
        sales: "", // 年销售额
      },
      ruleInline: {
        // 效验规则
        name: [
          { required: true, message: "公司全称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 3,
            message: "公司全称不能小于4位",
            trigger: "blur",
          },
          // {
          //   type: "string",
          //   max: 50,
          //   message: "公司全称不能大于50位",
          //   trigger: "blur"
          // }
        ],
        shortName: [
          { required: true, message: "公司简称不能为空", trigger: "blur" },
          {
            type: "string",
            min: 2,
            message: "公司简称不能小于2位",
            trigger: "blur",
          },
          {
            type: "string",
            max: 6,
            message: "公司简称不能大于6位",
            trigger: "blur",
          },
        ],
        introduction: [
          { required: true, message: "公司简介不能为空", trigger: "blur" },
          {
            type: "string",
            max: 2000,
            message: "公司简介不能超过2000字",
            trigger: "blur",
          },
        ],
        address: [{ required: true, message: "公司地址不能为空", trigger: "blur" }],
        country: [{ required: true, message: "国家/地区不能为空", trigger: "blur" }],
        // province: [
        //   {
        //     required: true,
        //     message: "请选择所在的省份",
        //     trigger: "change"
        //   }
        // ],
        // city: [
        //   { required: true, message: "请选择所在的城市", trigger: "change" }
        // ],
        province: [
          {
            required: true,
            validator: cityValid,
            trigger: "change",
          },
        ],
        city: [{ required: true, validator: cityValid, trigger: "change" }],

        Nature: [
          {
            required: true,
            message: "企业经营类型不能为空",
            trigger: "change",
          },
        ],
        BusinessType: [
          {
            required: true,
            message: "企业资产类型不能为空",
            trigger: "change",
          },
        ],

        // Website: [
        //   { required: true, message: "公司网址不能为空", trigger: "blur" },
        //   ...validator.Website
        // ],
        CreditCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: "blur",
          },
          ...validator.CreditCode,
        ],
        type: [{ required: true, message: "请选择企业类型", trigger: "change" }],
        staff: [{ required: true, message: "请输入人员规模", trigger: "blur" }],
        sales: [{ required: true, message: "请输入年销售额", trigger: "blur" }],
      },
      visible: false,
      defaultList: [],

      uploadList: [],

      coverImg: "",
      uploadVideoFlag: false,

      defaultList2: [],
      uploadList2: [],
      limitNum1: 1, // 图文显示的限制图片个数
      BusinessList: [], // 企业性质
      NatureList: [], // 企业经营类别

      commitInfo: null, // 公司信息提交记录
      editStatus: false,
      commitInfo2: null,
      albumOption: null, // 上传到素材库的信息
      albumOption2: null, // 上传到素材库的信息
      exTypeList: [],
      staffArr: [
        {
          value: "10人以下",
          label: "10人以下",
        },
        {
          value: "10~50人",
          label: "10~50人",
        },
        {
          value: "50~100人",
          label: "50~100人",
        },
        {
          value: "100~500人",
          label: "100~500人",
        },
        {
          value: "500~1000人",
          label: "500~1000人",
        },
        {
          value: "1000~5000人",
          label: "1000~5000人",
        },
        {
          value: "5000人以上",
          label: "5000人以上",
        },
      ],
      isEnableViewRole: null,
    };
  },
  components: {
    imgUpload,
    customComponentCommon,
    customComponentCommonDisplay,
    companyInfoBasicDisplay,
    companyInfoBasicEdit,
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
    Logo() {
      let logo = defaultLogo;
      if (this.company && this.company.logo) {
        logo = this.company.logo;
      }
      return logo;
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex",
      setCompany: "loginModule/setCompany",
    }),
    ...mapActions({
      getCompany: "loginModule/getCompany",
      editCompany: "companyModule/editCompany",
      getCountryList: "exhibitionModule/getCountryList",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      editCompanyDown: "companyModule/editCompanyDown",
      getCompanyDownList: "companyModule/getCompanyDownList",

      getNature: "companyInfoModule/getNature", // 获取企业性质
      getBusinessType: "companyInfoModule/getBusinessType", // 获取企业经营类别
      addMaterial: "materialModule/addMaterial",
      getCatalogueType: "exhibitionModule/getCatalogueType",
      getCityByParentId: "exhibitionModule/getCityByParentId",
    }),
    async init() {
      this.$handleSpinCustom();
      let company = await this.getCompany(this.user.id);
      this.setCompany(company);
      this.formInline.name = this.company.name;
      const commitInfo = await this.getCompanyDownList(this.joinInfo.joinId);
      if (commitInfo) {
        this.commitInfo = commitInfo;
        this.commitInfo2 = commitInfo.original;
        if (commitInfo.syncStatus === 2 && commitInfo.status === 1) {
          this.editStatus = false;
        } else {
          this.editStatus = true;
        }
      } else {
        this.commitInfo2 = this.company;
      }
      if (this.commitInfo2) {
        this.isEnableViewRole = this.commitInfo2.isEnableViewRole;
        this.formInline.shortName = this.commitInfo2.shortName;
        this.formInline.ShortNameEn = this.commitInfo2.shortNameEn;
        this.formInline.nameEn = this.commitInfo2.nameEn;
        this.formInline.address = this.commitInfo2.address;
        this.formInline.introduction = this.commitInfo2.introduction;
        this.formInline.Website = this.commitInfo2.website;
        this.formInline.CreditCode = this.commitInfo2.creditCode;
        this.formInline.Nature = this.commitInfo2.nature;
        this.formInline.BusinessType = this.commitInfo2.businessType;
        this.defaultList = [
          {
            name: this.commitInfo2.name,
            url: this.Logo,
            status: "finished",
            percentage: 100,
          },
        ];
        if (this.commitInfo2.businessLicenses) {
          this.defaultList2 = [
            {
              name: this.commitInfo2.name,
              url: this.commitInfo2.businessLicenses,
              status: "finished",
              percentage: 100,
            },
          ];
        }
        if (this.commitInfo2.country) {
          this.formInline.country = this.commitInfo2.country || "中国";
        }
        if (this.commitInfo2.province) {
          this.changeProvince(this.commitInfo2.province);
          this.formInline.province = this.commitInfo2.province || "";
        }
        if (this.commitInfo2.city) {
          this.changeCity(this.commitInfo2.city);
          this.formInline.city = this.commitInfo2.city || "";
        }
        this.uploadList = this.defaultList;
        this.uploadList2 = this.defaultList2;
        if (
          this.commitInfo2.introduction &&
          this.commitInfo2.introduction.indexOf("[") !== -1
        ) {
          this.Introduction = await this.transformCustomData(
            JSON.parse(this.commitInfo2.introduction)
          );
        }
        if (this.commitInfo2.industry) {
          this.formInline.type = this.commitInfo2.industry;
        }
        this.formInline.staff = this.commitInfo2.scale;
        this.formInline.sales = this.commitInfo2.annualSales;
      }

      this.BusinessList = await this.getNature();
      this.NatureList = await this.getBusinessType();
      let countryList = await this.getCountryList();
      if (countryList && countryList.length > 0) {
        this.countryList = countryList;
      }

      let provinceList = await this.getCityByParentId(
        "2710E818-5B91-4AA2-BCAD-0EF42A3DD6FD"
      );
      if (provinceList && provinceList.length > 0) {
        this.provinceArr = provinceList;
        let provinceId = "";
        this.provinceArr.map((c) => {
          if (c.shortname === this.formInline.province) {
            provinceId = c.id;
          }
        });
        if (provinceId) {
          let cityList = await this.getCityByParentId(provinceId);
          if (cityList && cityList.length > 0) {
            this.citiesArr = cityList;
          }
        }
      }
      let res = await this.getCatalogueType();
      if (res) {
        this.exTypeList = res;
      }
      this.$Spin.hide();
    },

   

    finish() {
      this.openBoolEdit = false;
      this.init();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove(file) {
      // const fileList = this.$refs.upload.fileList;
      // this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.albumOption.Path = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.sendImg();
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.albumOption2.Path = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
        this.sendImg2();
      }
    },
    sendImg() {
      this.addMaterial(this.albumOption)
        .then((c) => {})
        .catch((e) => {
          this.$Message.error("添加图片到素材库失败，请重新尝试");
        });
    },
    sendImg2() {
      this.addMaterial(this.albumOption2)
        .then((c) => {})
        .catch((e) => {
          this.$Message.error("添加图片到素材库失败，请重新尝试");
        });
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片",
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片",
      });
    },
    handleMaxSize2(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于4M的图片",
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    handleBeforeUpload2() {
      const limitNum = 1;
      const check = this.uploadList2.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`,
        });
      }
      return check;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadList = [];
      this.defaultList = [];
      this.$refs.upload.fileList = [];
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadList2 = [];
      this.defaultList2 = [];
      this.$refs.upload2.fileList = [];
      this.uploadChooseShowed2 = true;
      this.$refs.upload2.fileList = [];
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach((c) => {
        arr2.push(c.url);
      });
      return arr2;
    },
    // 拦截上传方法
    uploadLocal(album) {
      this.albumOption = album;
      this.$refs.upload.handleClick();
    },
    uploadLocal2(album) {
      this.albumOption2 = album;
      this.$refs.upload2.handleClick();
    },
    uploadCancel() {
      this.defaultList = [
        {
          name: this.company.name,
          url: this.company.logo,
          status: "finished",
          percentage: 100,
        },
      ];
      this.uploadList = this.defaultList;
    },
    uploadCancel2() {
      if (this.company.businessLicenses) {
        this.defaultList2 = [
          {
            name: this.company.name,
            url: this.company.businessLicenses,
            status: "finished",
            percentage: 100,
          },
        ];
      } else {
        this.defaultList2 = [];
      }
      this.uploadList2 = this.defaultList2;
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList.push({
            percentage: 100,
            status: "finished",
            url: item,
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    // 接收素材库上传的文件
    uploadMaterial2(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList2.push({
            percentage: 100,
            status: "finished",
            url: item,
          });
          this.uploadChooseShowed2 = false;
        }
      }
    },

    changeProvince(val) {
      // this.formInline.city = this.company.city || "";
      // for (var i = 0; i < this.provinceArr.length; i++) {
      //   if (val == this.provinceArr[i].value) {
      //     this.citiesArr = this.provinceArr[i].children;
      //     this.countyArr = [];
      //   }
      // }
    },
    async changeProvinceValue(item) {
      let cityList = await this.getCityByParentId(item.id);
      if (cityList && cityList.length > 0) {
        this.citiesArr = cityList;
      } else {
        this.formInline.city = "";
        this.citiesArr = [];
      }
    },

    changeCity(val) {
      // for (var i = 0; i < this.citiesArr.length; i++) {
      //   if (val == this.citiesArr[i].value) {
      //     this.countyArr = this.citiesArr[i].children;
      //   }
      // }
    },

    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let logo = "";
      let BusinessLicenses = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      }
      if (logo === "/static/img/empty.2bfdaae2.png") {
        logo = "";
      }
      if (this.uploadList2 && this.uploadList2.length) {
        BusinessLicenses = this.uploadList2[0].url;
      } else {
        this.$Message.error("请上传公司营业执照");
        return;
      }

      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error(`请完善详情信息`);
        return;
      }

      let req = {
        Id: this.company.id,
        ExhibitonId: this.exhibition.id,
        JoinId: this.joinInfo.joinId,
        CommandId: "2",
        SetValues: {
          Name: form.name,
          ShortName: form.shortName,
          ShortNameEn: form.ShortNameEn,
          Address: form.address,
          NameEn: form.nameEn,
          Logo: logo,
          Country: form.country,
          City: form.city,
          Province: form.province,
          Website: form.Website,
          CreditCode: form.CreditCode,
          BusinessType: form.BusinessType,
          BusinessLicenses: BusinessLicenses,
          Nature: form.Nature,
          Introduction: Introduction,
          Industry: form.type,
          Scale: form.staff,
          AnnualSales: form.sales,
          IsEnableViewRole: this.isEnableViewRole,
        },
      };
      const bool = await this.editCompanyDown(req);
      if (!bool) {
        this.$Message.error("提交未通过!");
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$Message.success("提交成功!");
      let company = await this.getCompany(this.user.id);
      this.setCompany(company);
      this.init();
      this.setActiveIndex(-1);
    },

    changModal($event) {
      this.Introduction = $event;
    },

    async getCommitInfo() {},
    // async getCommitInfo() {
    //   this.commitInfo = await this.getCompanyDownList(this.joinInfo.joinId);
    //   if (this.commitInfo) {
    //     if (this.commitInfo.syncStatus === 2 && this.commitInfo.status === 1) {
    //      this.editStatus = false;
    //     } else {
    //       this.editStatus = true;
    //     }
    //   }
    // }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  },
};
</script>

<style scoped lang="scss">
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.logo-example {
  display: flex;
  &-box {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
  &-item {
    display: flex;
    width: 100%;
    p {
      font-size: 12px;
      color: #808080;
      padding-left: 10px;
    }
    &.z-large-s {
      img {
        width: 40px;
        height: 40px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 40px;
      }
    }
    &.z-large-m {
      img {
        width: 30px;
        height: 30px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 30px;
      }
    }
    &.z-large-l {
      img {
        width: 20px;
        height: 20px;
        border: 1px solid #bfbfbf;
      }
      p {
        line-height: 20px;
      }
    }
  }
}
</style>
